// Valores por defecto de typesTipPrudenceSga.
export const defaultTypesTipPrudenceSga = () => {
    return [];
};

// Valor por defecto de action.
export const defaultActionTypeTipPrudence = () => {
    return "";
};

// Valor por defecto de typeTipPrudence.
export const defaultTypeTipPrudence = () => {
    return {
        id: null,
        name: null,
        sga_prudence_tip_type_languages: [],
    };
};

// Valores por defecto de filterTypesTipPrudenceSga.
export const defaultFilterTypesTipPrudenceSga = () => {
    return {
        name: null,
        page: 1,
        total: 0,
        per_page: 10,
    };
};

// Valores por defecto de activeTypesTipPrudenceSga.
export const defaultActiveTypesTipPrudence = () => {
    return [];
};

export default {
    typesTipPrudenceSga: defaultTypesTipPrudenceSga(),
    action: defaultActionTypeTipPrudence(),
    typeTipPrudence: defaultTypeTipPrudence(),
    filterTypesTipPrudenceSga: defaultFilterTypesTipPrudenceSga(),
    activeTypesTipPrudenceSga: defaultActiveTypesTipPrudence(),
};
